var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBinoculars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3252_2806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.125 16.8983C6.19607 16.8983 7.875 15.2193 7.875 13.1483C7.875 11.0772 6.19607 9.39825 4.125 9.39825C2.05393 9.39825 0.375 11.0772 0.375 13.1483C0.375 15.2193 2.05393 16.8983 4.125 16.8983Z",
    stroke: "#13100D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.875 4.52325V1.52325C7.56335 1.25121 7.16368 1.10131 6.75 1.10131C6.33632 1.10131 5.93665 1.25121 5.625 1.52325L4.5 4.52325L3.375 5.64825L1.125 10.8982",
    stroke: "#13100D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.875 16.8983C15.9461 16.8983 17.625 15.2193 17.625 13.1483C17.625 11.0772 15.9461 9.39825 13.875 9.39825C11.8039 9.39825 10.125 11.0772 10.125 13.1483C10.125 15.2193 11.8039 16.8983 13.875 16.8983Z",
    stroke: "#13100D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.125 4.52325V1.5705C10.4367 1.29846 10.8363 1.14857 11.25 1.14857C11.6637 1.14857 12.0633 1.29846 12.375 1.5705L13.5 4.52325L14.625 5.64825L16.875 10.8983",
    stroke: "#13100D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 7.52325C6 6.69825 7.34325 6.02325 9 6.02325C10.6568 6.02325 12 6.69825 12 7.52325",
    stroke: "#13100D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.875 13.1483V6.13275",
    stroke: "#13100D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.125 13.1483V6.13275",
    stroke: "#13100D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3252_2806"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinoculars);
export default __webpack_public_path__ + "static/media/binoculars.7c0fed5b378a23294a788d80ccb2226f.svg";
export { ForwardRef as ReactComponent };